import { render, staticRenderFns } from "./CertificateCenterSelectbox.vue?vue&type=template&id=ee1de780"
import script from "./CertificateCenterSelectbox.vue?vue&type=script&lang=js"
export * from "./CertificateCenterSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports